export enum ListSortOptions {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
  CUSTOM = 'custom',
}
